<div class="container py-5 register-container">
  <div class="text-center mb-4">
    <h2 class="fw-bold mb-1">Create account</h2>
    <div class="text-muted">Join SwipFx</div>
  </div>

  <div *ngIf="error" class="alert alert-danger" role="alert">
    {{ error }}
  </div>

  <div *ngIf="success" class="alert alert-success" role="alert">
    {{ success }}
  </div>

  <form class="card shadow-sm border-0" [formGroup]="form" (ngSubmit)="submit()">
    <div class="card-body p-4">
      <div class="row g-3">
        <div class="col-12">
          <label class="form-label">First name</label>
          <input type="text" class="form-control" formControlName="firstName" autocomplete="given-name"
            [class.is-invalid]="submitted && form.controls.firstName.invalid" />
          <div class="invalid-feedback">First name is required.</div>
        </div>

        <div class="col-12">
          <label class="form-label">Last name</label>
          <input type="text" class="form-control" formControlName="lastName" autocomplete="family-name"
            [class.is-invalid]="submitted && form.controls.lastName.invalid" />
          <div class="invalid-feedback">Last name is required.</div>
        </div>

        <div class="col-12">
          <label class="form-label">Email</label>
          <input type="email" class="form-control" formControlName="email" autocomplete="email"
            [class.is-invalid]="submitted && form.controls.email.invalid" />
          <div class="invalid-feedback">Enter a valid email.</div>
        </div>

        <div class="col-12">
          <label class="form-label">Country</label>
          <select class="form-select country-select" formControlName="country" autocomplete="country"
            (change)="onCountryChanged()" [class.is-invalid]="submitted && form.controls.country.invalid">
            <option value="" disabled>
              {{ countriesLoading ? 'Loading countries...' : 'Select country' }}
            </option>
            <option *ngFor="let country of countries" [value]="country.code">
              {{ countryFlag(country.code) }} {{ country.name }}
            </option>
          </select>
          <div class="invalid-feedback">Select your country.</div>

          <div *ngIf="countriesLoading" class="form-text d-flex align-items-center gap-2">
            <span class="spinner-border spinner-border-sm" aria-hidden="true"></span>
            Loading available countries...
          </div>

          <div *ngIf="countriesError" class="country-load-error mt-2">
            <span>{{ countriesError }}</span>
            <button type="button" class="btn btn-link btn-sm p-0 ms-1" (click)="loadCountries()">
              Retry
            </button>
          </div>
        </div>

        <div class="col-12">
          <label class="form-label">Password</label>
          <input type="password" class="form-control" formControlName="password" autocomplete="new-password"
            [class.is-invalid]="submitted && form.controls.password.invalid" />
          <div class="invalid-feedback">Password must be at least 8 characters.</div>
          <div class="form-text">Include uppercase, lowercase, a number, and a special character.</div>
        </div>

        <div class="col-12">
          <label class="form-label">Confirm password</label>
          <input type="password" class="form-control" formControlName="confirmPassword" autocomplete="new-password"
            [class.is-invalid]="submitted && (form.controls.confirmPassword.invalid || form.controls.password.value !== form.controls.confirmPassword.value)" />
          <div class="invalid-feedback">Confirm the same password.</div>
        </div>

        <div class="col-12">
          <label class="form-label">
            Phone number
            <span class="text-muted fw-normal">(optional)</span>
          </label>

          <div class="input-group phone-input-group">
            <span class="input-group-text phone-prefix" *ngIf="selectedCountry && selectedDialCode">

              <span class="phone-flag">
                {{ selectedCountryFlag }}
              </span>

              <span>{{ selectedDialCode }}</span>
            </span>

            <input type="tel" inputmode="tel" class="form-control" formControlName="phone" autocomplete="tel"
              [placeholder]="phonePlaceholder" [readonly]="!selectedCountry"
              [class.is-invalid]="submitted && phoneInvalid" (input)="onPhoneInput($event)" />
          </div>

          <div *ngIf="submitted && phoneInvalid" class="invalid-feedback d-block">

            Enter a valid international phone number or leave it blank.
          </div>

          <div *ngIf="selectedCountry && !phoneEntrySupported" class="form-text">

            Enter the complete international number, including the country code.
            Example: <strong>+1 555 123 4567</strong>.
          </div>

          <div *ngIf="selectedCountry && phoneEntrySupported && !phoneInternationalPreview" class="form-text">

            The country code is added automatically. Do not type
            {{ selectedDialCode }} again.
          </div>

          <div *ngIf="phoneInternationalPreview" class="form-text phone-preview">

            Your number will be saved as
            <strong>{{ phoneInternationalPreview }}</strong>.
          </div>
        </div>
      </div>

      <button class="btn btn-success w-100 mt-4" type="submit"
        [disabled]="loading || countriesLoading || !!countriesError">
        <span *ngIf="!loading">Create account</span>
        <span *ngIf="loading" class="d-inline-flex align-items-center gap-2">
          <span class="spinner-border spinner-border-sm" aria-hidden="true"></span>
          Creating...
        </span>
      </button>

      <div class="text-center mt-3">
        <a routerLink="/auth/login" class="text-decoration-none">Already have an account? Login</a>
      </div>
    </div>
  </form>
</div>